import { PHONE_MASK, INN_MASK, PHONE_PLACEHOLDER } from "@/consts";
import { useDataFormStore } from "@/stores/form";
import { limitInput } from "@/utils/handleChangeForm"
import { getArrayOfRules } from "@/utils/getDataForm"
import { getNameOrganization } from "@/utils/getDataForm";

export default {
  setup() {
    const dataForm = useDataFormStore();

    const options = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];
    const optionsWhoPays = [
      {
        value: "Отправитель",
        label: "Отправитель",
      },
      {
        value: "Получатель",
        label: "Получатель",
      },
      {
        value: "Третье лицо",
        label: "Третье лицо",
      },
    ];

    let checkThirdPerson = (whoPays) => whoPays === "Третье лицо";

    return {
      dataForm,
      options,
      optionsWhoPays,
      PHONE_MASK,
      INN_MASK,
      PHONE_PLACEHOLDER,
      limitInput,
      getArrayOfRules,
      getNameOrganization,

      clearThirdPerson: function () {
        if (
          !checkThirdPerson(dataForm.thirdPerson.cargoTransportationCustomer)
        ) {
          dataForm.payment.whoPaysForCargoPickup = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoPickup
          )
            ? dataForm.payment.whoPaysForCargoPickup
            : "";
          dataForm.payment.whoPaysForCargoTransportation = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoTransportation
          )
            ? dataForm.payment.whoPaysForCargoTransportation
            : "";
          dataForm.payment.whoPaysForCargoDelivery = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoDelivery
          )
            ? dataForm.payment.whoPaysForCargoDelivery
            : "";
          dataForm.payment.whoPaysForCargoExtraPacking = !checkThirdPerson(
            dataForm.payment.whoPaysForCargoExtraPacking
          )
            ? dataForm.payment.whoPaysForCargoExtraPacking
            : "";
        }
      },
    };
  },
};
